import React, { useCallback, useMemo } from 'react';
import Statuses from '../../../../model/Statuses';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import useT from '../../utils/Translations/useT';
import SelectBoxFilter from './SelectBoxFilter';
const ALL_VALUE = 'ALL';
const StatusSelectorWithAll = ({ onChange, value, label, name, menuClassName, dataCy, }) => {
    const t = useT();
    const { options, allOptions, optionsByValue } = useEnumerableModel(Statuses);
    const allOptionsWithValue = useMemo(() => ({
        ...allOptions,
        value: ALL_VALUE,
        sequence: 0,
    }), [allOptions]);
    const statusOptions = useMemo(() => [allOptionsWithValue, { divider: true }, ...options], [options, allOptionsWithValue]);
    const valueWithFallback = useMemo(() => {
        const valueWithFallback = value ? optionsByValue[value] : undefined;
        if (!value || !valueWithFallback) {
            return allOptionsWithValue.value;
        }
        return valueWithFallback.value;
    }, [optionsByValue, value, allOptionsWithValue]);
    const handleChange = useCallback((nextValue) => onChange && onChange(nextValue === ALL_VALUE ? null : nextValue), [onChange]);
    const title = useMemo(() => (label ? label : t('Status')), [t, label]);
    return (<SelectBoxFilter includeAll dataCy={dataCy} menuClassName={menuClassName} name={name} options={statusOptions} title={title} value={valueWithFallback} onChange={handleChange}/>);
};
export default StatusSelectorWithAll;
